import { SparklesIcon } from '../../automationStudioIcons';
import ButtonComponent from '../../../customButton';
import { AUTOMATION_STUDIO_EMPTY_CONTENT } from '../../content';
import EmptyFlowSteps from './EmptyFlowSteps';
import ExampleChip from './ExampleChip';
import styles from '../../../../styles/automationStudio/emptyPanel.module.scss';

export default function AutomationStudioEmptyPanel({
    onStartAutomation,
    onTryExample,
}) {
    const content = AUTOMATION_STUDIO_EMPTY_CONTENT;

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <p className={styles.badge}>
                    <SparklesIcon className={styles.badgeIcon} aria-hidden="true" />
                    {content.badge}
                </p>
                <h2 className={styles.title}>{content.title}</h2>
                <p className={styles.description}>{content.description}</p>

                <EmptyFlowSteps />

                <div className={styles.examplePanel}>
                    <p className={styles.examplePanelTitle}>{content.examplePanelTitle}</p>
                    <ExampleChip onTryExample={onTryExample} />
                </div>

                <ButtonComponent
                    ctaText={content.startAutomationLabel}
                    variant="primary"
                    className={`white bg-blue600 ${styles.cta}`}
                    onClick={onStartAutomation}
                    size="small"
                />
            </div>
        </div>
    );
}
